import { Button, Container } from "react-bootstrap";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import AthleteProfileTemplate from "./AthleteProfileTemplate";
import { useAthleteProfileData } from "./useAthleteProfileData";
import "./AthleteProfilePage.css";

type AthleteProfileLocationState = {
	fromPath?: string;
	fromLabel?: string;
};

const AthleteProfilePage = () => {
	const { riderId } = useParams<{ riderId: string }>();
	const navigate = useNavigate();
	const location = useLocation();
	const locationState = (location.state ?? {}) as AthleteProfileLocationState;
	const fromPath = locationState.fromPath;
	const fromLabel = locationState.fromLabel;

	const {
		rider,
		history,
		seasonHistory,
		seasonOptions,
		selectedSeasonKey,
		setSelectedSeasonKey,
		isLoading,
		error,
	} = useAthleteProfileData({
		riderId,
		enabled: Boolean(riderId),
	});

	return (
		<Container className="athlete-profile-page py-4" style={{ minHeight: "100vh" }}>
			<nav aria-label="breadcrumb" className="athlete-profile-page__breadcrumb mb-3">
				<ol className="breadcrumb mb-0">
					<li className="breadcrumb-item">
						<Link className="athlete-profile-page__crumb-link" to="/">
							Home
						</Link>
					</li>
					<li className="breadcrumb-item">
						<Link className="athlete-profile-page__crumb-link" to={fromPath || "/riders"}>
							{fromLabel || "Riders"}
						</Link>
					</li>
					<li
						className="breadcrumb-item active athlete-profile-page__crumb-active"
						aria-current="page"
					>
						Athlete Profile
					</li>
				</ol>
			</nav>
			<div className="d-flex justify-content-between align-items-center mb-3 gap-2 flex-wrap">
				<h2 className="athlete-profile-page__title mb-0">Athlete Profile</h2>
				<Button
					variant="outline-light"
					size="sm"
					onClick={() => navigate(fromPath || "/riders")}
				>
					{fromLabel ? `Back to ${fromLabel}` : "Back to Riders"}
				</Button>
			</div>
			<AthleteProfileTemplate
				rider={rider}
				history={history}
				seasonHistory={seasonHistory}
				seasonOptions={seasonOptions}
				selectedSeasonKey={selectedSeasonKey}
				onSeasonChange={setSelectedSeasonKey}
				isLoading={isLoading}
				error={riderId ? error : "Missing rider id."}
			/>
		</Container>
	);
};

export default AthleteProfilePage;
